(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3622],{

/***/ 16552:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[myname]",
      function () {
        return __webpack_require__(14043);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70655);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_api_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58124);
/* harmony import */ var _components_pages_company_CompanyPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56337);
/* harmony import */ var _lib_api_contentful__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58585);
/* harmony import */ var _lib_api_smartround__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43585);










var CompanyMynamePage = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_pages_company_CompanyPage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
};
CompanyMynamePage.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(ctx) {
        var myname, company, slideBannerArticles, staticBanners, floatingBanner, smartroundUrl, companyMemo, companyStatus, companyContactPerson, ref;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    myname = ctx.query.myname;
                    return [
                        4,
                        (0,_lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* .fetchCompanyByMyname */ .vy)(ctx, myname)
                    ];
                case 1:
                    company = _state.sent();
                    slideBannerArticles = null;
                    staticBanners = null;
                    floatingBanner = null;
                    smartroundUrl = null;
                    companyMemo = {
                        memo: null
                    };
                    companyStatus = {
                        companyStatus: null
                    };
                    companyContactPerson = {
                        contactPerson: null
                    };
                    if (!company) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            (0,_lib_api_contentful__WEBPACK_IMPORTED_MODULE_3__/* .getNpStartupSlideBannerArticles */ .V6)(),
                            (0,_lib_api_contentful__WEBPACK_IMPORTED_MODULE_3__/* .getNpStartupStaticBanner */ .yy)(),
                            (0,_lib_api_contentful__WEBPACK_IMPORTED_MODULE_3__/* .getNpStartupFloatingBanner */ .T4)(),
                            (0,_lib_api_smartround__WEBPACK_IMPORTED_MODULE_4__/* .getSmartroundUrl */ .m)(ctx, company !== null ? company.corporateNumber : null),
                            (0,_lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* .getCompanyMemo */ .t1)(ctx, company.shortname),
                            (0,_lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* .getCompanyStatus */ .jy)(ctx, company.shortname),
                            (0,_lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* .getCompanyContactPerson */ .QU)(ctx, company.shortname)
                        ])
                    ];
                case 2:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        4
                    ]), slideBannerArticles = ref[0], staticBanners = ref[1], floatingBanner = ref[2], smartroundUrl = ref[3], ref;
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        {
                            company: company,
                            slideBannerArticles: slideBannerArticles,
                            staticBanners: staticBanners,
                            floatingBanner: floatingBanner,
                            smartroundUrl: smartroundUrl,
                            companyMemo: companyMemo.memo,
                            companyStatus: companyStatus.companyStatus,
                            companyContactPerson: companyContactPerson.contactPerson,
                            reCaptchaEnabled: false
                        }
                    ];
            }
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (CompanyMynamePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3662,8687,519,8674,8101,9198,6066,5998,774,3431,3954,9635,8328,9967,9871,655,8331,6337,2888,179], function() { return __webpack_exec__(16552); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);